import {
	Component,
	ContentChildren,
	QueryList,
	AfterContentInit,
	Input,
	OnChanges,
	Output,
	EventEmitter
} from '@angular/core';
import { TabComponent } from './tab.component';

@Component({
	selector: 'cv-tab-group',
	templateUrl: './tab-group.component.html',
	styleUrls: ['./tab.component.scss']
})
export class TabGroupComponent implements AfterContentInit, OnChanges {
	CurrentTab: string;
	/**
	 * @private get the tab content to work with it
	 */
	@ContentChildren(TabComponent) tabs: QueryList<TabComponent>;

	/**
	 * @public set the active tab
	 */
	@Input() setActive: string;

	@Output() getCurrentTab: EventEmitter<TabComponent> = new EventEmitter<
		TabComponent
	>();
	/**
	 * setActiveTab
	 * * set the active tab when a tab is clicked
	 * @param tab  tab to be active
	 */
	setActiveTab(tab: TabComponent): void {
		tab.tabActivated.emit({ tab: tab });
		this.getCurrentTab.emit(tab);
		this.tabs.forEach(t => (t.active = false));
		tab.active = true;
		this.CurrentTab = tab.title;
	}

	ngOnChanges(): void {
		if (this.setActive && this.tabs) {
			const active = this.tabs.filter(
				t => t.title === this.setActive || t.icon === this.setActive
			);
			if (active.length) {
				this.setActiveTab(active[0]);
			}
		}
	}

	/**
	 * ngAfterContentInit
	 * * set the firts tab element if there is not one specifyed
	 */
	ngAfterContentInit(): void {
		const activeTab = this.tabs.filter(t => t.active);
		if (!activeTab.length) {
			this.setActiveTab(this.tabs.first);
		}
	}
}
